import React from 'react';
import { ConfirmModal } from '../ConfirmModal';
import { Loader } from '../Loader';
import { DialogBox } from '../Dialog';
import { EmailConfirmContent } from './EmailConfirmContent';

var _ref = /*#__PURE__*/React.createElement(Loader, null);

export const EmailModal = ({
  open,
  onClose,
  siteEmailList,
  emailOption,
  setEmailOption,
  subject,
  onSubjectChange,
  comments,
  onCommentsChange,
  onSubmit
}) => /*#__PURE__*/React.createElement(DialogBox, {
  open: open,
  disableBackdropClick: true,
  handleClick: onClose,
  disableScrollLock: true,
  fullWidth: true,
  maxWidth: "xs",
  title: "Email Report"
}, !siteEmailList && _ref, /*#__PURE__*/React.createElement(ConfirmModal, {
  onOKClick: onSubmit,
  okText: "Send Email",
  isOkDisabled: !(emailOption !== null && emailOption !== void 0 && emailOption.recipientemail) || !(emailOption !== null && emailOption !== void 0 && emailOption.recipientname),
  onCancelClick: () => {
    onClose();
    setEmailOption(null);
  },
  noText: "Cancel",
  modalText: "",
  style: {
    width: '100%'
  },
  content: /*#__PURE__*/React.createElement(EmailConfirmContent, {
    siteEmailList: siteEmailList,
    setEmailOption: setEmailOption,
    emailOption: emailOption,
    subject: subject,
    onSubjectChange: onSubjectChange,
    comments: comments,
    onCommentsChange: onCommentsChange
  })
}));